import { render } from "./logo_music.vue?vue&type=template&id=4c029e4b&scoped=true"
import script from "./logo_music.vue?vue&type=script&lang=js"
export * from "./logo_music.vue?vue&type=script&lang=js"

import "./logo_music.vue?vue&type=style&index=0&id=4c029e4b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c029e4b"]])

export default __exports__